import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Routes, useLocation } from "react-router-dom";


import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import AdminSidebar from "components/Sidebar/AdminSidebar.js";


import ErrorBoundary from "components/ErrorBoundary";
import adminRoutes from "adminRoutes.js";


var ps;

function Dashboard(props) {
  const [backgroundColor, setBackgroundColor] = React.useState("red");
  const [activeColor, setActiveColor] = React.useState("info");
  const mainPanel = React.useRef();
  const location = useLocation();
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);
 
  return (
    <div className="wrapper">
      <AdminSidebar
        {...props}
        routes={adminRoutes}
        bgColor={backgroundColor}
        activeColor={activeColor}
        
      />
      <div className="main-panel" ref={mainPanel}>
        <AdminNavbar {...props} />
        <ErrorBoundary>
          <Routes>
            {adminRoutes.map((prop, key) => {
              return (
                <Route
                  path={prop.path}
                  element={prop.component}
                  key={key}
                  exact
                />
              );
            })}
          </Routes>
        </ErrorBoundary>
        {/* <Footer fluid /> */}
      </div>
      
    </div>
  );
}

export default Dashboard;
